var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M22.6448 2.54755C22.3639 2.19442 21.9431 2 21.4598 2C21.1971 2 20.9188 2.05681 20.6328 2.16917L1.16379 9.80764C0.13059 10.2129 -0.0085622 10.821 0.000387049 11.1475C0.0093363 11.4739 0.181829 12.073 1.23574 12.4177C1.24205 12.4197 1.24837 12.4217 1.25469 12.4235L5.29308 13.6113L7.47705 20.03C7.77484 20.9051 8.44322 21.4487 9.22163 21.4487C9.71244 21.4487 10.1952 21.2373 10.6177 20.8376L13.1156 18.4737L16.7387 21.4721C16.739 21.4725 16.7395 21.4726 16.7399 21.473L16.7743 21.5015C16.7774 21.504 16.7808 21.5067 16.7839 21.5093C17.1866 21.8303 17.6262 21.9998 18.0556 22H18.0558C18.8947 22 19.5628 21.3617 19.7574 20.3741L22.9473 4.18497C23.0754 3.53516 22.968 2.9537 22.6448 2.54755ZM6.64407 13.3856L14.4354 9.29471L9.58399 14.5929C9.5045 14.6797 9.44817 14.7859 9.42045 14.9015L8.48499 18.796L6.64407 13.3856ZM9.70472 19.8186C9.67243 19.8491 9.63997 19.8764 9.6075 19.9014L10.4754 16.2886L12.0542 17.5953L9.70472 19.8186ZM21.6265 3.90993L18.4366 20.0993C18.4059 20.2542 18.3078 20.6147 18.0556 20.6147C17.931 20.6147 17.7745 20.5449 17.6143 20.4181L13.5089 17.0206C13.5083 17.0201 13.5076 17.0196 13.5069 17.0192L11.0641 14.9975L18.0798 7.33555C18.3044 7.09027 18.3248 6.71459 18.1281 6.44515C17.9312 6.1757 17.5744 6.09093 17.2826 6.24423L5.74371 12.303L1.65038 11.0993L21.1134 3.4632C21.2779 3.39863 21.3926 3.38511 21.4598 3.38511C21.5011 3.38511 21.5744 3.39016 21.6016 3.4246C21.6374 3.46951 21.683 3.62263 21.6265 3.90993Z"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }